(function (global) {
  var SAMPLE_HANDLE = 'kostenloses-muster';
  // Hoechstens 2 Muster je Bestellung, fuer alle Kunden (Inhaber 02.11.2026;
  // der Abonnenten-Bonus entfaellt). Die Grenze ist wie bisher nur eine
  // Browser-Grenze - Muster sind kostenlos, es gibt keine serverseitige Pruefung.
  var MAX_SAMPLES = 2;

  // Vinyl-Muster kosten uns Geld (Inhaber 13.10.2026): sie bleiben fuer den
  // Kunden kostenlos, aber hoechstens 2 je Bestellung. Gezaehlt werden Warenkorbzeilen mit der Property
  // _Muster_Gruppe = vinyl (setzt buildCartItems). Dieselbe Typliste steht in
  // snippets/tp-muster-grenze.liquid (Knopf auf der Produktseite).
  // Teppichboden und alle anderen Muster: unveraendert die Gesamtgrenze oben.
  var VINYL_TYPES = ['klickvinyl', 'klebevinyl', 'vinyl von der rolle'];
  var VINYL_MAX = 2;
  var VINYL_GROUP = 'vinyl';

  function isVinyl(product) {
    if (!product) return false;
    return VINYL_TYPES.indexOf(String(product.type || '').trim().toLowerCase()) !== -1;
  }

  // Muster dieser Marken verschickt der Hersteller selbst und direkt an den
  // Kunden (Inhaber 15.10.2026: Vorwerk-Teppichboden, JAB-Teppichboden auch
  // nach Mass, JAB-Vinyl). Die Musterseite sagt das dazu - der Kunde bekommt
  // sonst Post von einem Absender, den er nicht erwartet.
  var HERSTELLER_MUSTER = ['vorwerk', 'jab anstoetz'];

  function isHerstellerMuster(product) {
    if (!product) return false;
    return HERSTELLER_MUSTER.indexOf(String(product.vendor || '').trim().toLowerCase()) !== -1;
  }

  // Der Konfigurator listet die Werte EINER Produktoption als Muster. Welche
  // Option das ist, heisst je nach Sortiment anders: Teppich- und Vinylboden
  // fuehren "Farbe", folierte Sockelleisten "Dekor". Dieselbe Liste steht in
  // snippets/tp-musteroption.liquid, das entscheidet, wohin der Muster-Link
  // zeigt - beide muessen gleich bleiben.
  var OPTION_NAMES = ['farbe', 'dekor', 'color'];

  // Fuer diese neu importierten Produktarten wurden bewusst keine Muster
  // angelegt (Laminat, Parkett, Kork: Muster nur auf Anfrage, Inhaber 14.10.2026).
  // Ohne Sperre wuerde der Konfigurator den generischen kostenlosen
  // Musterartikel fuer ein nicht vorhandenes physisches Muster verwenden.
  function canSample(product) {
    if (!product) return false;
    var type = String(product.type || '').trim().toLowerCase();
    if (['laminat', 'parkett', 'kork'].indexOf(type) !== -1) return false;
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    return !tags.some(function (tag) {
      var name = String(tag || '').trim().toLowerCase();
      return name === 'zubehoer' || name === 'ohne-muster';
    });
  }

  function findOption(product) {
    return (product.options || []).find(function (entry) {
      return OPTION_NAMES.indexOf(String(entry.name || '').trim().toLowerCase()) !== -1;
    });
  }

  function colorPosition(product) {
    var option = findOption(product);
    return option ? Number(option.position) : 0;
  }

  // Sichtbare Bezeichnung fuer Oberflaeche und Warenkorbzeile: der echte
  // Optionsname des Produkts, nicht ein fest verdrahtetes "Farbe".
  function getOptionName(product) {
    var option = findOption(product);
    var name = option ? String(option.name || '').trim() : '';
    return name || 'Farbe';
  }

  function getOptionTerm(product, form) {
    var name = getOptionName(product).toLowerCase();
    if (name === 'dekor') return form === 'plural' ? 'Dekore' : 'Dekor';
    return form === 'plural' ? 'Farben' : 'Farbe';
  }

  // Technische Varianten des Preisrechners. Sie tragen einen generierten
  // Titel wie "opc-1771104793780" und sind keine echte Farbe. Ohne diesen
  // Filter erscheinen sie als bestellbares Muster - siehe Softiq Teppichboden,
  // wo genau das passierte. Der Rollenware-Rechner filtert sie an anderer
  // Stelle bereits nach demselben Muster.
  function isTechnicalVariant(variant, value) {
    return /^opc-/i.test(String(value || '')) || /opc-/i.test(String(variant.title || ''));
  }

  function getUniqueColors(product) {
    var position = colorPosition(product);
    if (!position) {
      // C3: Einzeldekor ohne Farboption (z. B. Vinyl, je Dekor ein Produkt) -
      // das Produkt selbst ist das eine Muster, benannt nach dem Titel vor " – ".
      var einzel = (product.variants || []).find(function (variant) { return variant.available; });
      if (!einzel) return [];
      var dekor = String(product.title || '').split(' – ')[0].trim();
      return [{
        value: dekor || String(product.title || ''),
        variantId: einzel.id,
        image: product.featured_image || '',
        exactImage: '',
      }];
    }
    var seen = Object.create(null);
    return (product.variants || []).reduce(function (colors, variant) {
      var value = variant['option' + position];
      if (isTechnicalVariant(variant, value)) return colors;
      if (!variant.available || !value || seen[value]) return colors;
      seen[value] = true;
      // "image" darf auf das Produkt-Hauptbild zurueckfallen - das traegt die
      // Auswahlkarte auf /pages/muster, wo jede Farbe ohnehin ein Bild zeigen
      // soll. "exactImage" bleibt leer, wenn die Variante kein eigenes Bild
      // hat: das ist die Grundlage fuer das Warenkorb-Musterfoto, das lieber
      // gar kein Bild zeigt als moeglicherweise die falsche Farbe.
      var exactImage = variant.featured_image && variant.featured_image.src
        ? variant.featured_image.src
        : '';
      colors.push({
        value: value,
        variantId: variant.id,
        image: exactImage || product.featured_image || '',
        exactImage: exactImage,
      });
      return colors;
    }, []);
  }

  function slug(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function sampleKey(handle, color) {
    return slug(handle) + '--' + slug(color);
  }

  // Musterzeilen erkennt man an der Property _Muster_ID, nicht an einer
  // Varianten-ID: seit 2026-09-16 hat jedes Muster eine eigene Variante im
  // Musterprodukt seiner Qualitaet ("Muster Piumera Teppichboden" / Farbe).
  // Das Sammelprodukt "Kostenloses Muster" bleibt nur als Rueckfall.
  function getSampleState(cart) {
    var keys = new Set();
    var vinylCount = 0;
    var count = ((cart && cart.items) || []).reduce(function (total, item) {
      if (!item.properties || !item.properties._Muster_ID) return total;
      keys.add(item.properties._Muster_ID);
      if (item.properties._Muster_Gruppe === VINYL_GROUP) vinylCount += Number(item.quantity || 0);
      return total + Number(item.quantity || 0);
    }, 0);
    return { count: count, vinylCount: vinylCount, remaining: Math.max(0, MAX_SAMPLES - count), keys: keys };
  }

  // Welche Grenze fuer dieses Produkt gerade bindet. Fuer Vinyl gelten zwei:
  // die Gesamtgrenze und die Vinyl-Grenze (beide 2). Angezeigt und
  // gezaehlt wird die engere - bei gleichem Rest die Vinyl-Grenze, damit der
  // Kunde liest, warum es nicht weitergeht ("2 von 2 Vinyl-Mustern").
  function getLimit(product, state) {
    var total = { max: MAX_SAMPLES, inCart: state.count, remaining: Math.max(0, MAX_SAMPLES - state.count), word: 'Muster' };
    if (!isVinyl(product)) return total;
    var vinyl = { max: VINYL_MAX, inCart: state.vinylCount, remaining: Math.max(0, VINYL_MAX - state.vinylCount), word: 'Vinyl-Muster' };
    return vinyl.remaining <= total.remaining ? vinyl : total;
  }

  // Handle des Musterprodukts einer Qualitaet. Angelegt wird es je
  // Quellprodukt mit einer Variante pro Farbe, SKU "M-<Quell-SKU>"; so steht
  // die Farbe im Variantentitel und damit auf Lieferschein, Kommissionierliste,
  // in beiden Bestellmails und im Admin - ohne Sonderlogik.
  function sampleProductHandle(productHandle) {
    return 'muster-' + slug(productHandle);
  }

  // Ordnet jeder Farbe die passende Variante des Musterprodukts zu. Drei Faelle
  // je Farbe (Inhaber 16.10.2026):
  // - Mustervariante vorhanden und verfuegbar: sampleVariantId = ihre ID.
  // - Mustervariante fehlt (Farbe im Quellprodukt neu, Musterprodukt noch nicht
  //   nachgezogen): sampleVariantId null, buildCartItems nimmt den Rueckfall -
  //   das Muster ist weiter bestellbar, nur ohne eigene SKU.
  // - Mustervariante vorhanden, aber nicht verfuegbar (Bestand 0, Richtlinie
  //   deny - so sperrt das Control Center ein Muster, das der Lieferant nicht
  //   mehr liefern kann): sampleUnavailable true, sampleVariantId null und KEIN
  //   Rueckfall. Der Konfigurator zeigt die Farbe als "Kein Muster verfuegbar".
  function assignSampleVariants(colors, sampleProduct, optionName) {
    var available = Object.create(null);
    var known = Object.create(null);
    var position = 0;
    (sampleProduct && sampleProduct.options || []).forEach(function (entry) {
      if (String(entry.name || '').trim().toLowerCase() === String(optionName || '').trim().toLowerCase()) {
        position = Number(entry.position);
      }
    });
    if (position) {
      (sampleProduct.variants || []).forEach(function (variant) {
        var value = String(variant['option' + position] || '').trim().toLowerCase();
        if (!value) return;
        known[value] = true;
        if (variant.available && !available[value]) available[value] = variant.id;
      });
    }
    return colors.map(function (color) {
      var key = String(color.value || '').trim().toLowerCase();
      var hit = available[key];
      var copy = {};
      Object.keys(color).forEach(function (name) { copy[name] = color[name]; });
      copy.sampleVariantId = hit || null;
      copy.sampleUnavailable = !hit && known[key] === true;
      return copy;
    });
  }

  // Sperrliste fuer Muster ueber das Sammelprodukt (Inhaber 03.11.2026, w-194):
  // Ohne eigenes Musterprodukt greift die Mustersperre des Control Centers
  // nicht. Eintrag: 'produkt-handle': ['Farbe', ...]. Die Farbe erscheint dann
  // als "Kein Muster verfuegbar" und kommt nie in den Warenkorb.
  var MUSTER_SPERRLISTE = {};

  function applySperrliste(colors, handle, liste) {
    var gesperrt = ((liste || MUSTER_SPERRLISTE)[handle] || []).map(function (farbe) {
      return String(farbe).trim().toLowerCase();
    });
    if (!gesperrt.length) return colors;
    return colors.map(function (color) {
      if (gesperrt.indexOf(String(color.value || '').trim().toLowerCase()) === -1) return color;
      var copy = {};
      Object.keys(color).forEach(function (name) { copy[name] = color[name]; });
      copy.sampleVariantId = null;
      copy.sampleUnavailable = true;
      return copy;
    });
  }

  // Gesperrte Farben (sampleUnavailable) sind nie waehlbar und zaehlen nicht
  // zur Auswahlgrenze.
  function isSelectable(color) {
    return Boolean(color) && color.sampleUnavailable !== true;
  }

  // Alle Farben gesperrt: der Konfigurator zeigt statt der Karten den Hinweis
  // "Fuer dieses Produkt sind derzeit keine Muster verfuegbar."
  function allSamplesUnavailable(colors) {
    return Array.isArray(colors) && colors.length > 0 && !colors.some(isSelectable);
  }

  // Teppich nach Mass, Zwischenstufe vor dem Sammelprodukt: fehlt das
  // Musterprodukt muster-<handle> ganz, nennt die Section tp-muster-basis
  // (Section Rendering API im Kontext des Produkts) den Handle des
  // Teppichbodens, aus dem zugeschnitten wird (service.einfass_basis). Dessen
  // Musterprodukt ist dasselbe physische Muster.
  var BASIS_SECTION = 'tp-muster-basis';
  var BASIS_RX = /<script[^>]*\bdata-tp-muster-basis\b[^>]*>([\s\S]*?)<\/script>/i;

  function basisSectionUrl(productHandle) {
    return '/products/' + encodeURIComponent(String(productHandle || '')) + '?section_id=' + BASIS_SECTION;
  }

  // Liest nur den JSON-Text im Script-Tag der Section. Alles andere - keine
  // Antwort, kein Tag, kein Text, ein fremdes Zeichen im Handle, Verweis auf
  // sich selbst - ergibt null, und es bleibt beim bisherigen Rueckfall.
  function parseBasisHandle(html, productHandle) {
    var match = BASIS_RX.exec(String(html || ''));
    if (!match) return null;
    var value;
    try { value = JSON.parse(match[1]); } catch (error) { return null; }
    if (typeof value !== 'string') return null;
    value = value.trim();
    if (!/^[a-z0-9-]+$/.test(value) || value === String(productHandle || '')) return null;
    return value;
  }

  // Dieselbe Section nennt, welche Musterprodukte es gibt (eigen = muster-<handle>,
  // basis = Musterprodukt des Teppichbodens), damit der Konfigurator nichts
  // blind abruft. Ein leerer Wert heisst: gibt es nicht. Fehlt das Tag oder ist
  // es kaputt, null - dann gilt der alte Weg ueber den Probe-Abruf.
  var QUELLE_RX = /<script[^>]*\bdata-tp-muster-quelle\b[^>]*>([\s\S]*?)<\/script>/i;

  function parseMusterQuelle(html) {
    var match = QUELLE_RX.exec(String(html || ''));
    if (!match) return null;
    var value;
    try { value = JSON.parse(match[1]); } catch (error) { return null; }
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    function handleOderNull(entry) {
      if (typeof entry !== 'string') return undefined;
      entry = entry.trim();
      if (entry === '') return null;
      return /^muster-[a-z0-9-]+$/.test(entry) ? entry : undefined;
    }
    var eigen = handleOderNull(value.eigen);
    var basis = handleOderNull(value.basis);
    if (eigen === undefined || basis === undefined) return null;
    return { eigen: eigen, basis: basis };
  }

  // Reihenfolge der Musterquelle: das eigene Musterprodukt der Qualitaet
  // (muster-<handle>), unveraendert je Farbe wie bisher. Nur wenn es das gar
  // nicht gibt, das Musterprodukt des Teppichbodens - und auch das nur fuer
  // Farben, die es mit demselben Optionswert fuehrt. Alles Uebrige bleibt
  // ohne sampleVariantId und geht auf das Sammelprodukt kostenloses-muster -
  // ausser die Farbe steht im Musterprodukt als nicht verfuegbar (gesperrt).
  function assignSampleVariantsWithBasis(colors, ownSample, basisSample, optionName) {
    return assignSampleVariants(colors, ownSample || basisSample || null, optionName);
  }

  // max/word optional: ohne Angabe die Gesamtgrenze ("Muster"), fuer Vinyl
  // die Vinyl-Grenze aus getLimit ("Vinyl-Muster").
  function getSelectionStatus(cartCount, selectedCount, max, word) {
    var limit = Number(max) > 0 ? Number(max) : MAX_SAMPLES;
    var wort = word || 'Muster';
    var inCart = Math.max(0, Number(cartCount || 0));
    var newlySelected = Math.max(0, Number(selectedCount || 0));
    var total = Math.min(limit, inCart + newlySelected);
    var remaining = Math.max(0, limit - total);
    var message;

    if (total === 0) {
      message = '0 von ' + limit + ' ' + wort + 'n ausgewählt';
    } else if (total >= limit) {
      if (inCart === 0) {
        message = limit + ' von ' + limit + ' ' + wort + 'n ausgewählt. Wählen Sie eine Farbe ab, um eine andere auszuwählen.';
      } else if (newlySelected === 0) {
        message = limit + ' von ' + limit + ' ' + wort + 'n im Warenkorb. Entfernen Sie dort zuerst ein ' + wort + ', um ein anderes auszuwählen.';
      } else {
        message = limit + ' von ' + limit + ' ' + wort + 'n erreicht. Wählen Sie eine Farbe ab oder entfernen Sie ein ' + wort + ' im Warenkorb.';
      }
    } else {
      var location = newlySelected === 0 ? ' im Warenkorb' : ' insgesamt ausgewählt';
      var possibility = remaining === 1 ? 'noch 1 weiteres möglich' : remaining + ' weitere möglich';
      message = total + ' von ' + limit + ' ' + wort + 'n' + location + ' · ' + possibility;
    }

    return {
      total: total,
      remaining: remaining,
      limitReached: total >= limit,
      message: message,
    };
  }

  // Gesperrte Farben (sampleUnavailable) kommen nie in den Warenkorb, auch
  // nicht ueber den Rueckfall auf das Sammelprodukt.
  function buildCartItems(args) {
    var optionName = args.optionName || getOptionName(args.product);
    return args.colors.filter(isSelectable).map(function (color) {
      var eigeneVariante = Boolean(color.sampleVariantId);
      var properties = {
        _Muster_ID: sampleKey(args.product.handle, color.value),
        _Quellprodukt: args.product.handle,
        _Quellprodukt_ID: String(args.product.id),
        _Quellvariante_ID: String(color.variantId),
        // Nur das eigene Variantenbild, nie der Produkt-Fallback von
        // "image" - der Warenkorb soll kein Bild zeigen, statt moeglicherweise
        // die falsche Farbe.
        _Bild: color.exactImage || '',
        _Produktlink: args.origin + '/products/' + args.product.handle,
      };
      // Mit eigener Variante stehen Produkt und Farbe im Titel der Zeile
      // ("Muster Piumera Teppichboden - Taupe Dunkel"). Nur der Rueckfall auf
      // das Sammelprodukt "Kostenloses Muster" braucht sie als Properties,
      // sonst wuesste niemand, welches Muster gemeint ist.
      if (!eigeneVariante) {
        properties.Produkt = args.product.title;
        properties[optionName] = color.value;
      }
      // Kennzeichen fuer die Vinyl-Grenze (getSampleState, snippets/tp-muster-grenze).
      if (isVinyl(args.product)) properties._Muster_Gruppe = VINYL_GROUP;
      return {
        id: Number(eigeneVariante ? color.sampleVariantId : args.sampleVariantId),
        quantity: 1,
        properties: properties,
      };
    });
  }

  global.TPSampleCheckoutCore = {
    SAMPLE_HANDLE: SAMPLE_HANDLE,
    MAX_SAMPLES: MAX_SAMPLES,
    VINYL_MAX: VINYL_MAX,
    isVinyl: isVinyl,
    isHerstellerMuster: isHerstellerMuster,
    getLimit: getLimit,
    canSample: canSample,
    getUniqueColors: getUniqueColors,
    getOptionName: getOptionName,
    getOptionTerm: getOptionTerm,
    sampleKey: sampleKey,
    getSampleState: getSampleState,
    sampleProductHandle: sampleProductHandle,
    assignSampleVariants: assignSampleVariants,
    isSelectable: isSelectable,
    allSamplesUnavailable: allSamplesUnavailable,
    basisSectionUrl: basisSectionUrl,
    parseBasisHandle: parseBasisHandle,
    parseMusterQuelle: parseMusterQuelle,
    applySperrliste: applySperrliste,
    assignSampleVariantsWithBasis: assignSampleVariantsWithBasis,
    getSelectionStatus: getSelectionStatus,
    buildCartItems: buildCartItems,
  };
})(window);
